import React, { useState } from 'react';

interface Campaign { id:number; name:string; type:string; status:'Active'|'Draft'|'Paused'|'Completed'; sent:number; opens:number; replies:number; created:string; }

const MOCK: Campaign[] = [
  {id:1,name:'Q2 Life Insurance Push',type:'Email',status:'Active',sent:248,opens:142,replies:31,created:'2026-04-01'},
  {id:2,name:'Renewal Reminder — May Policies',type:'SMS',status:'Active',sent:87,opens:80,replies:12,created:'2026-04-05'},
  {id:3,name:'Whale Prospect Outreach',type:'Email',status:'Draft',sent:0,opens:0,replies:0,created:'2026-04-10'},
  {id:4,name:'Commercial Auto Q1 Follow-up',type:'Email',status:'Completed',sent:156,opens:89,replies:22,created:'2026-03-15'},
  {id:5,name:'Phoenix Drip — New Clients',type:'Email Sequence',status:'Active',sent:48,opens:41,replies:9,created:'2026-04-08'},
];

const sColor: Record<string,string> = { Active:'bg-green-100 text-green-700', Draft:'bg-gray-100 text-gray-600', Paused:'bg-yellow-100 text-yellow-700', Completed:'bg-blue-100 text-blue-700' };

const CampaignManager: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>(MOCK);
  const [showModal, setShowModal] = useState(false);
  const [newCamp, setNewCamp] = useState({ name:'', type:'Email' });
  const toggle = (id:number) => setCampaigns(p=>p.map(c=>c.id===id?{...c,status:c.status==='Active'?'Paused':'Active' as any}:c));

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Campaign Manager</h1>
        <button onClick={()=>setShowModal(true)} className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">+ New Campaign</button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[['Active',campaigns.filter(c=>c.status==='Active').length,'text-green-600'],['Total Sent',campaigns.reduce((s,c)=>s+c.sent,0).toLocaleString(),'text-blue-600'],['Total Opens',campaigns.reduce((s,c)=>s+c.opens,0).toLocaleString(),'text-purple-600'],['Replies',campaigns.reduce((s,c)=>s+c.replies,0).toLocaleString(),'text-yellow-600']].map(([l,v,c])=>(
          <div key={l as string} className="bg-white rounded-xl border border-gray-200 p-4">
            <p className="text-xs text-gray-500">{l}</p>
            <p className={`text-2xl font-bold mt-1 ${c}`}>{v}</p>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>{['Campaign','Type','Status','Sent','Opens','Replies','Open Rate',''].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase whitespace-nowrap">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {campaigns.map(c=>(
              <tr key={c.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium text-gray-900">{c.name}</td>
                <td className="px-4 py-3 text-gray-500">{c.type}</td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${sColor[c.status]}`}>{c.status}</span></td>
                <td className="px-4 py-3 text-gray-600">{c.sent.toLocaleString()}</td>
                <td className="px-4 py-3 text-gray-600">{c.opens.toLocaleString()}</td>
                <td className="px-4 py-3 text-gray-600">{c.replies}</td>
                <td className="px-4 py-3 text-gray-600">{c.sent>0?Math.round(c.opens/c.sent*100):0}%</td>
                <td className="px-4 py-3">
                  {(c.status==='Active'||c.status==='Paused') && (
                    <button onClick={()=>toggle(c.id)} className="text-xs text-blue-600 hover:text-blue-800 font-medium">{c.status==='Active'?'Pause':'Resume'}</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-semibold mb-4">New Campaign</h2>
            <div className="space-y-3">
              <input placeholder="Campaign name" value={newCamp.name} onChange={e=>setNewCamp(p=>({...p,name:e.target.value}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
              <select value={newCamp.type} onChange={e=>setNewCamp(p=>({...p,type:e.target.value}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
                {['Email','SMS','Email Sequence','Phone Outreach'].map(t=><option key={t}>{t}</option>)}
              </select>
            </div>
            <div className="flex gap-3 mt-4">
              <button onClick={()=>{if(newCamp.name){setCampaigns(p=>[...p,{id:Date.now(),name:newCamp.name,type:newCamp.type,status:'Draft',sent:0,opens:0,replies:0,created:new Date().toISOString().split('T')[0]}]);setShowModal(false);}}} className="flex-1 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">Create Draft</button>
              <button onClick={()=>setShowModal(false)} className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default CampaignManager;
